
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gwoQm", function(module, exports) {

$parcel$export(module.exports, "loadingSpinner", () => $c072e7e9da7baaac$export$deaa9e6d912ce6c6);
$parcel$export(module.exports, "errorPopup", () => $c072e7e9da7baaac$export$ec267e3635bd0be4);
$parcel$export(module.exports, "successPopup", () => $c072e7e9da7baaac$export$89dc853842deb0b3);
$parcel$export(module.exports, "formatTimestamp", () => $c072e7e9da7baaac$export$bfe4ac50319c1d9b);
$parcel$export(module.exports, "refreshTooltips", () => $c072e7e9da7baaac$export$a2bc61e91eae259f);
$parcel$export(module.exports, "auditLink", () => $c072e7e9da7baaac$export$b49df0c9c7ae6e6d);

var $dwTAg = parcelRequire("dwTAg");
const $c072e7e9da7baaac$export$deaa9e6d912ce6c6 = `
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span class="sr-only">Loading...</span>
`;
function $c072e7e9da7baaac$export$ec267e3635bd0be4(error) {
    console.error(error);
    $('#error-toast-body').text(error);
    new bootstrap.Toast($('#error-toast')).show();
}
function $c072e7e9da7baaac$export$89dc853842deb0b3(message) {
    console.info(`Success: ${message}`);
    $('#success-toast-body').text(message);
    new bootstrap.Toast($('#success-toast')).show();
}
function $c072e7e9da7baaac$export$bfe4ac50319c1d9b(timestamp) {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString("en-US", {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }).replace(' at ', '<br />');
}
function $c072e7e9da7baaac$export$72439bf08da4c934(e) {
    const addressControl = e.currentTarget;
    navigator.clipboard.writeText(addressControl.dataset.bsOriginalTitle);
    addressControl.style.transition = '';
    addressControl.style.setProperty('color', 'green', 'important');
    addressControl.style.opacity = '0.75';
    setTimeout(function() {
        addressControl.style.transition = 'color 1s, opacity 1s';
        addressControl.style.removeProperty('color');
        addressControl.style.opacity = '1';
    }, 50);
    setTimeout(function() {
        addressControl.style.transition = '';
    }, 600);
}
function $c072e7e9da7baaac$export$a2bc61e91eae259f() {
    $('[data-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('.pretty-address').click($c072e7e9da7baaac$export$72439bf08da4c934);
}
function $c072e7e9da7baaac$export$b49df0c9c7ae6e6d(chainID, verificationReferenceID) {
    return `<a href="#" onClick="AuditRequest=window.open('${window.location.origin}/audit/?chain-id=${chainID}&verification-reference-id=${verificationReferenceID}','AuditRequest','width=450,height=560'); return false;">${(0, $dwTAg.prettyAddress)(verificationReferenceID, false)}</a>`;
}
var $c072e7e9da7baaac$export$2e2bcd8739ae039 = {
    loadingSpinner: $c072e7e9da7baaac$export$deaa9e6d912ce6c6,
    errorPopup: $c072e7e9da7baaac$export$ec267e3635bd0be4,
    successPopup: $c072e7e9da7baaac$export$89dc853842deb0b3,
    formatTimestamp: $c072e7e9da7baaac$export$bfe4ac50319c1d9b,
    copyAddress: $c072e7e9da7baaac$export$72439bf08da4c934,
    refreshTooltips: $c072e7e9da7baaac$export$a2bc61e91eae259f,
    auditLink: $c072e7e9da7baaac$export$b49df0c9c7ae6e6d
};

});
parcelRegister("dwTAg", function(module, exports) {

$parcel$export(module.exports, "prettyAddress", () => $9d996150ec4a9bef$export$f80bcf15052a775);
function $9d996150ec4a9bef$export$f80bcf15052a775(address, copy = true) {
    if (address === undefined || address.length != 42 && address.length != 66) return address;
    const shortAddress = `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
    return copy ? `<span class="pretty-address" data-toggle="tooltip" data-placement="top" title="${address}">${shortAddress} <i class="fa-solid fa-copy"></i></span>` : shortAddress;
}
var $9d996150ec4a9bef$export$2e2bcd8739ae039 = {
    prettyAddress: $9d996150ec4a9bef$export$f80bcf15052a775
};

});



var $gwoQm = parcelRequire("gwoQm");
async function $2493d344644bf301$var$fetchComplianceData() {
    try {
        const chainID = $('#chain-id').val();
        const verificationRefID = $('#verification-reference-id').val();
        $('#get-compliance-data').html((0, $gwoQm.loadingSpinner));
        const complianceData = await (verificationRefID.length == 66 && verificationRefID.startsWith('0x') ? getFullComplianceData(chainID, verificationRefID) : getComplianceData(chainID, verificationRefID));
        (0, $gwoQm.successPopup)('Compliance data fetched successfully');
        $('#compliance-data').text(complianceData);
    } catch (error) {
        (0, $gwoQm.errorPopup)(error);
        $('#compliance-data').text('');
    } finally{
        $('#get-compliance-data').text('Get compliance data');
    }
}
$(document).ready(function() {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('verification-reference-id')) $('#verification-reference-id').val(searchParams.get('verification-reference-id'));
    if (searchParams.has('chain-id')) $('#chain-id').val(searchParams.get('chain-id'));
    $('#fetch-compliance-data-form').on('submit', function(e) {
        e.preventDefault();
        $2493d344644bf301$var$fetchComplianceData();
    });
});


//# sourceMappingURL=index.b79d3950.js.map
